<template lang="pug">
  form(v-on:submit.prevent="submitForm()")
    .modal-card
      header.modal-card-head
        p.modal-card-title {{label}} Lembrete
      section.modal-card-body
        b-field(label="Item")
          b-input(type="text", v-model="reminder.name", placeholder="Nome do Item" maxlength="300")
        b-field(label="Tipo")
          b-select(placeholder="Selecionar...", v-model="reminder.type", expanded)
            option(value="Recorrente") Recorrente
            option(value="Pontual") Pontual
        b-field(label="Valor Médio")
          b-input(type="text", v-model.lazy="reminder.value", placeholder="Valor Médio", v-validate="validations.value" name="value" data-vv-as="valor" v-money="{}")
        b-field(label="Dia*" v-bind:message="errors.first('day')" v-bind:type="isDanger('day')")
            b-select(placeholder="Selecionar...", v-model="reminder.day", expanded)
              option(v-for="n in 31" v-bind:value="n") Dia {{n}}

      footer.modal-card-foot
        button.button.is-primary Salvar
        a.button.is-danger(type="button", @click="$parent.close()") Cancelar
</template>

<script>
  import UtilService from '@/services/util.js'

  export default {
    data () {
      return {
      }
    },
    computed: {
      label () {
        return (this.reminder._id) ? 'Editar' : 'Cadastrar'
      },
      validations () {
        return {
          day: {rules: {required: true}},
          name: {rules: {required: true}},
          type: {rules: {required: true}},
          value: {rules: {required: true}}
        }
      },
      reminder () {
        return {
          _id: this.data._id,
          name: this.data.name,
          type: this.data.type,
          day: 1,
          value: this.data.value.toFixed(2)
        }
      }
    },
    props: {
      data: {
        required: false,
        default: () => {
          return {
            name: '',
            type: undefined,
            value: 0,
            day: 1
          }
        }
      }
    },
    methods: {
      isDanger (fieldName) {
        if (this.$validator.errors.has(fieldName)) return 'is-danger'
      },
      submitForm () {
        this.$validator.validateAll().then(success => {
          if (!success || this.disabled) return
          let data = JSON.parse(JSON.stringify(this.reminder))
          data.value = UtilService.money.unformat(data.value, 2)

          this.$emit('submit', data)
          this.$parent.close()
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "~@/assets/sass/common.sass"
  .modal-card
    width: auto
    +desktop
      width: 50vw
</style>



// WEBPACK FOOTER //
// ReminderModal.vue?8e934ca2